<template>
  <div class="dashboard-main-wrapper">
    <!---------------------- layout left navbar ---------------------->
    <app-navbar></app-navbar>

    <div class="dashboard-wrapper nice-scroll">
      <!---------------------- dashboard-content ---------------------->
      <div class="dashboard-content container-fluid d-flex flex-column">
        <!-- control spinner by vue component (show/hide) -->
        <div v-if="spinnerLoading" class="spinner-overlay-dark spinner-position-cover">
          <div class="spinner-position-center">
            <span class="spinner-border"></span>
          </div>
        </div>
        <!-- control spinner by id (show/hide) -->
        <div id="loader-spinner" class="spinner-overlay-dark spinner-position-cover">
          <div class="spinner-position-center">
            <span class="spinner-border"></span>
          </div>
        </div>

        <div v-if="success.message" class="alert-box d-flex justify-content-center">
          <div class="c-pointer text-center card info-hide">
            <div class="card-body">
              <i class="icofont-tick-mark"></i> <em>{{ success.message }}</em>
            </div>
          </div>
        </div>

        <div class="page">
          <div v-show="barLoading" id="loader-bar" class="loader-bar-inner">
            <div class="bar-loader">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>

          <div class="page-header">
            <h4 class="page-header-title">{{ title }}</h4>
          </div>
          <div v-show="!barLoading" id="page-container" class="page-container">
            <router-view />
          </div>
        </div>
        <!---------------------- footer ---------------------->
        <app-footer></app-footer>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "vue-modal-service/dist/modal-service.css";
@import "bootstrap/dist/css/bootstrap.css";
@import "@/assets/vendor/icofont/css/icofont.min.css";
@import "@/assets/vendor/open-sans/style.css";
@import "@/assets/css/theme.css";
@import "@/assets/css/style.css";
</style>

<script>
import Navbar from "./Navbar.vue";
import Footer from "./Footer.vue";
import { mapGetters } from "vuex";

export default {
  name: "Layout",

  components: {
    appNavbar: Navbar,
    appFooter: Footer,
  },

  data() {
    return {
      title: "DASHBOARD",
      success: {},
    };
  },

  computed: mapGetters(["spinnerLoading", "barLoading"]),

  mounted() {
    document.title = "Safari-Tz";
    // set dynamic dashboard title
    if (this.$route.name === "operatorPackage" && this.$route.query.act === "management") {
      this.title = "OPERATOR PACKAGES MANAGEMENT";
    } else if (this.$route.name === "operatorPackage" && this.$route.query.act === "rearrangement") {
      this.title = "OPERATOR PACKAGES REARRANGEMENT";
    } else {
      this.title = this.$route.meta.title;
    }
  },
};
</script>
